import { useState } from 'react';
import { cn } from '@/lib/utils';
import { User, ChevronDown, ChevronUp } from 'lucide-react';

export function UserNode({ query, isSmallScreen }: { query: string; isSmallScreen: boolean }) {
  const [expanded, setExpanded] = useState(false);
  const truncated = query.length > 120;
  const isActive = true;

  return (
    <div
      className={cn(
        'relative flex items-start border transition-all duration-500 overflow-hidden w-full',
        'backdrop-blur-md bg-gradient-to-br rounded-xl',
        isSmallScreen ? 'gap-2 p-3' : 'gap-3 p-4',
        isActive
          ? 'from-blue-500/15 to-blue-600/5 border-blue-500/40 shadow-lg shadow-blue-500/10'
          : 'from-card-idle-from/60 to-card-idle-to/40 border-border/50'
      )}
      data-active={isActive}
    >
      {/* Subtle inner glow */}
      {isActive && (
        <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-blue-400/5 to-transparent pointer-events-none" />
      )}
      <div className={cn(
        'relative rounded-lg flex items-center justify-center transition-all duration-300 flex-shrink-0',
        isSmallScreen ? 'w-8 h-8' : 'w-10 h-10',
        isActive ? 'bg-blue-500/25 shadow-inner' : 'bg-surface-light/80'
      )}>
        <User className={cn(
          'transition-all duration-300',
          isSmallScreen ? 'w-4 h-4' : 'w-5 h-5',
          isActive ? 'text-blue-400 drop-shadow-[0_0_8px_rgba(59,130,246,0.5)]' : 'text-text-muted'
        )} />
      </div>
      <div className="relative flex-1 min-w-0">
        <div className={cn(
          'font-mono uppercase text-text-secondary tracking-wider',
          isSmallScreen ? 'text-[11px]' : 'text-xs'
        )}>User Query</div>
        <div className={cn(
          'text-text-primary font-medium break-words',
          isSmallScreen ? 'text-sm' : 'text-base',
          !expanded && truncated && 'line-clamp-2'
        )}>
          {query || 'Awaiting query...'}
        </div>
        {truncated && (
          <button
            className="mt-1 text-xs text-blue-400 hover:text-blue-300 flex items-center gap-1"
            onClick={(e) => { e.stopPropagation(); setExpanded(!expanded); }}
          >
            {expanded ? <ChevronUp className="w-3 h-3" /> : <ChevronDown className="w-3 h-3" />}
            {expanded ? 'Show less' : 'Show more'}
          </button>
        )}
      </div>
    </div>
  );
}
